import React from 'react';
import { LayerWrapper } from './layer';

export const Layers = React.memo(
  ({
    layers,
    tileSourceOptions,
    hasNewLayers,
    filters,
    timelines,
    selectedDateRange,
    forceDots,
  }) => {
    const layerElements = layers.map((layer) => {
      const { key, label } = layer;

      const layerAllowsDots = layer.forceDots ? forceDots : false;
      return (
        <LayerWrapper
          forceDots={layerAllowsDots}
          key={`${key}-${label}-${layer.style.type}-${layerAllowsDots ? 'as-dots' : ''}`}
          layer={layer}
          filters={filters}
          tileSourceOptions={tileSourceOptions}
          hasNewLayers={hasNewLayers}
          timelines={timelines}
          selectedDateRange={selectedDateRange}
        />
      );
    });
    return layerElements;
  },
);
